import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CognitoAuth } from 'amazon-cognito-auth-js';
import { ProfileService } from './profile.service';
import { TranslationService } from '../translation/translation.service';
import { TokenAccessorService } from './token.accessor.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { Observable } from 'rxjs/Observable';
import { DocumentListItem } from '../audit/document.model';
import { catchError, map } from 'rxjs/operators';
import { DOC_LIST_BY_CMR_ID_API } from '../api.constants';

/**
 * Authentication service
 */
@Injectable()
export class AuthenticationService {

    public static USER_KEY: string = 'user';

    /**
     * The "constructor"
     * @param {Router} router
     * @param {TokenAccessorService} tokenAccessor
     * @param {ProfileService} profile
     * @param {TranslationService} translationService
     * @param http
     */
    constructor(private router: Router,
                private tokenAccessor: TokenAccessorService,
                private profile: ProfileService,
                private translationService: TranslationService,
                private http: HttpClient) {
    }

    /**
     * Init for the mock version
     */
    public initMock(login: string) {
        this.translationService.use('en');
        this.tokenAccessor.setToken('token');
        this.profile.loadMockProfile(login);
    }

    public login(username: string, password: string) {
        return this.http.post('/api/authenticate', JSON.stringify({username, password})).pipe(
            map(res => {
                if (res !== 'Username or password is incorrect') {
                    localStorage.setItem(AuthenticationService.USER_KEY, JSON.stringify(res));
                    this.initMock(username);
                } else {
                    throw Error(res as string);
                }
            })
        );
    }

    public logout() {
        localStorage.removeItem(AuthenticationService.USER_KEY);
    }

    public isLoggedIn() {
        return !!localStorage.getItem(AuthenticationService.USER_KEY);
    }

    /**
     * Error handler
     * @param {HttpErrorResponse} error
     * @returns {ErrorObservable}
     */
    public handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else if (error.error) {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: `);
            console.error(error.error);
            if (error.status === 401 || error.status === 0) {
                return Observable.throw(error.message ? error.message : error.status + ' ' + error.statusText);
            }
        }
        return new ErrorObservable(
            'Error occurred: ' + ((error && error.error && error.error.message) ?
            error.error.message : error.status + ' ' + error.statusText));
    }
}



// WEBPACK FOOTER //
// ./src/app/services/security/authentication.service.ts